// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"199":"ListCollectionCreator","266":"Screenshot","544":"ToolSourceDisplay","621":"workflowLayout","637":"cite","837":"PairCollectionCreator"}[chunkId] || chunkId) + ".bundled.js";
};